import { ModelRow, Navigation, UrlUtil } from "@mcleod/core";
import { AutogenLayoutProcessCommissionsExceptionTable } from "./autogen/AutogenLayoutProcessCommissionsExceptionTable";
import { DataSource, ClickEvent, Button, TableRowDisplayEvent } from "@mcleod/components";
export interface CommissionsException {
    payee_id:string,
    order_id: string,
    movement_id: string,
    deduct_code: string,
    exception_message: string,
    commissions_ids: string,
    payee_name: string,
    drillDown: boolean
}
export class ProcessCommissionsExceptionTable extends AutogenLayoutProcessCommissionsExceptionTable {
    public addWarningsAndExceptions(exceptions: CommissionsException[]) {
        this.tableExceptions.dataSource = new DataSource();
        exceptions.forEach(exception => {
            const newRowData = new ModelRow("", false);
            if (newRowData != null) {
                newRowData.set("payee_id", exception.payee_id);
                newRowData.set("deduct_code", exception.deduct_code);
                newRowData.set("exception_message", exception.exception_message);
                newRowData.set("commissions_ids", exception.commissions_ids);
                newRowData.set("payee_name", exception.payee_name);
                newRowData.set("drillDown", exception.drillDown);
                this.tableExceptions.addRow(newRowData, null, { display: true, addToData: true });
            }
        });
    }


    /** This is an event handler for the onClick event of buttonDrillDown. */
    buttonDrillDownOnClick(event: ClickEvent) {
        const urlParams: string[] = [];
        const button = event.target as Button;
        const commissionIds = button.boundRow.get("commissions_ids");
        const commissionIdsString = commissionIds.join(",");
        urlParams.push(`id=${commissionIdsString}`);
        Navigation.navigateTo("lme/settlement/commissions/CommissionsProcessing" + UrlUtil.buildQueryString(urlParams), {newTab: true});
    }

    /** This is an event handler for the onRowDisplay event of tableExceptions. */
    tableExceptionsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const data = tableRow.data as ModelRow;

        const buttonDrillDown = tableRow.findComponentById("buttonDrillDown") as Button;
        if (buttonDrillDown) {
            buttonDrillDown.visible = data.getBoolean("drillDown");
        }
    }
}
